import React from 'react';
import { useTranslation } from 'react-i18next';

// styles
import * as Buttons from 'theme/components/Buttons.style';
import { Shapes } from 'icons/untitledui';

// context
import { useUser } from 'shared/hooks/api/user';

// hooks
import useCanAccessConversations from 'eCoach/hooks/useCanAccessConversations';
import useTourState from 'productTours/hooks/useTourState';

export default function ButtonOpenTour(): React.ReactElement | null {
  const { t } = useTranslation('productTour');
  const { data: user } = useUser();
  const { startTour } = useTourState({ user });
  const canAccessConversations = useCanAccessConversations();

  if (!canAccessConversations) return null;

  return (
    <Buttons.SecondaryDark onClick={startTour} small>
      <Shapes.Star06 />
      {t('Take a tour')}
    </Buttons.SecondaryDark>
  );
}
